import React, { Component } from "react";
import PropTypes from "prop-types";
import { CARD_ICONS } from "@constants";
import { Modal, Image } from "../../../../../components";

import "./PaymentMethods.scss";

export class PaymentMethods extends Component {
	constructor(props) {
		super(props);
		this.state = {
			show: false,
			selection: null,
		};

		this.initialState = { ...this.state };
	}

	openModal = () => {
		this.setState({ show: true });
	};

	onConfirm = () => {
		const { onConfirm } = this.props;
		const { selection } = this.state;

		onConfirm(selection);
		this.resetModal();
	};

	onCancel = () => {
		this.resetModal();
	};

	resetModal = () => this.setState(this.initialState);

	changePaymentMethod = paymentMethod => () => {
		this.setState({ selection: paymentMethod });
	};

	render() {
		const { show, selection } = this.state;
		const { paymentMethods, selectedMethod, openAddPaymentMethodModal } = this.props;
		const { lang } = global;

		return (
			<Modal
				show={show}
				onHide={this.onCancel}
				id="payment-methods-modal"
			>
				<Modal.Header closeButton>
					<Modal.Title>{lang.t("Payment Methods")}</Modal.Title>
				</Modal.Header>
				<Modal.Body>
					<div className="text-center">
						<button
							type="button"
							name="add-new-payment-method"
							className="btn btn-link"
							onClick={openAddPaymentMethodModal}
						>
							{lang.t("Add Payment Method")}
						</button>
						<div className="row-separator" />
					</div>
					<For
						each="item"
						index="index"
						of={paymentMethods}
					>
						<div
							className="row"
							key={`payment_method_${item.id}`}
						>
							<div className="col-sm-6 payment-method-name">
								<Choose>
									<When condition={item.type === "bank_account"}>
										<span>
											{`${item.bankName} ${lang.t("ending in")} ${item.accNumber}`}
										</span>
									</When>
									<When condition={item.type === "card"}>
										<Image
											className="payment-methods-card-image"
											src={CARD_ICONS[item.cardType] || CARD_ICONS.default}
										/>
										<span>{` ${lang.t("ending in")} ${item.cardNumber}`}</span>
									</When>
								</Choose>
							</div>
							<div className="col-sm-6">
								<Choose>
									<When
										condition={
											selection?.id === item.id ||
											(selection === null && selectedMethod?.id === item.id)
										}
									>
										<small className="payment-methods-badge-success">
											{` ${lang.t("Active").toUpperCase()} `}
										</small>
									</When>
									<Otherwise>
										<button
											type="button"
											className="btn btn-link payment-methods-btn-setMethod"
											onClick={this.changePaymentMethod(item)}
										>
											{lang.t("Select as Payment Method")}
										</button>
									</Otherwise>
								</Choose>
							</div>
						</div>
						<If condition={index !== paymentMethods.length - 1}>
							<div className="row-separator" />
						</If>
					</For>
				</Modal.Body>
				<Modal.Footer>
					<button
						type="button"
						onClick={this.onCancel}
						className="btn btn-link"
					>
						{lang.t("Cancel")}
					</button>
					<button
						type="button"
						className="btn btn-primary"
						onClick={this.onConfirm}
					>
						{lang.t("Confirm")}
					</button>
				</Modal.Footer>
			</Modal>
		);
	}
}

PaymentMethods.propTypes = {
	paymentMethods: PropTypes.array,
	selectedMethod: PropTypes.object,
	onConfirm: PropTypes.func.isRequired,
	openAddPaymentMethodModal: PropTypes.func.isRequired,
};

PaymentMethods.defaultProps = {
	paymentMethods: [],
	selectedMethod: null,
};

export default PaymentMethods;
